The details of the questionnaire to be created.
